import clsx from "clsx";
import React from "react";
import LeadLink from "web/react/components/lead-link/lead-link";
import { gettext } from "web/script/modules/django-i18n";
import { ProductCardSerializer } from "web/types/serializers";
import styles from "./product-gallery-more-products.module.css";

interface MoreProductsProps {
    products: ProductCardSerializer[];
    fullscreen?: boolean;
}

interface ProductProps {
    product: ProductCardSerializer;
}

function Product({ product }: ProductProps): React.ReactElement {
    const content = (
        <div>
            <img className={styles.product} src={product.image_url || ""} />
        </div>
    );

    return (
        <div className={styles.card}>
            {product.lead_enabled && product.lead_url ? (
                <LeadLink
                    reason="image-gallery-related"
                    href={product.lead_url}
                    openInNewTab={true}
                >
                    {content}
                </LeadLink>
            ) : (
                <a href={product.url}>{content}</a>
            )}
        </div>
    );
}

function MoreProducts({ products, fullscreen = false }: MoreProductsProps): React.ReactElement {
    const renderedProducts = products.map((product) => {
        return <Product key={product.image_url as string} product={product} />;
    });

    const wrapperClasses = clsx(styles.wrapper, {
        [styles.fullscreen]: fullscreen,
    });

    return (
        <div className={wrapperClasses}>
            <div className={styles.container}>
                <h3 className={styles.title}>
                    {gettext("product.product_more_details_try_instead")}
                </h3>
                <div className={styles.products}>{renderedProducts}</div>
            </div>
        </div>
    );
}

export default MoreProducts;
